export function timeTo(date?: string | number | Date | null) {
  const { locale } = useLocale()
  return useNuxtApp().$dayjs().locale(locale.value).to(date)
}

export function localizedTime(date?: string | number | Date | null) {
  const { locale } = useLocale()
  return useNuxtApp().$dayjs(date).locale(locale.value).format('LLL')
}
